<template>
  <VaDropdown :offset="[13, 0]" class="user-menu-dropdown" stick-to-edges :close-on-content-click="false">
    <template #anchor>
      <VaButton preset="secondary" color="textPrimary">
        <VaBadge overlap>
          <div class="flex items-center gap-2">
            <div class="flex flex-col justify-center">
              <p class="font-semibold text-sm leading-4">{{ authStore.user?.data?.userName }}</p>
              <p class="text-xs text-secondary leading-4">{{ authStore.user?.data?.email }}</p>
            </div>
            <VaIcon :size="32" name="mso-account_circle" class="shrink-0" />
          </div>
        </VaBadge>
      </VaButton>
    </template>
    <VaDropdownContent class="h-full sm:max-w-[420px] sm:h-auto">
      <section class="sm:max-h-[320px] p-4 overflow-auto">
        <VaButton preset="secondary" color="textPrimary" class="w-full justify-start" @click="Perfil">
          <VaIcon name="mso-person" class="mr-2" />
          Perfil
        </VaButton>
        <VaButton preset="secondary" color="textPrimary" class="w-full justify-start" @click="Preferencias">
          <VaIcon name="mso-settings" class="mr-2" />
          Preferencias
        </VaButton>
        <VaDivider />
        <VaButton color="danger" preset="primary" class="w-full" @click="logout">
          <VaIcon name="mso-power_settings_new" class="mr-2" />
          Cerrar sesión
        </VaButton>
      </section>
    </VaDropdownContent>
  </VaDropdown>
</template>

<script setup lang="ts">
import { useToast, VaBadge, VaButton, VaDivider, VaDropdown, VaDropdownContent, VaIcon } from 'vuestic-ui'
import { useRouter } from 'vue-router'
import { useAuthStore } from '~/stores/useAuthStore'

const { init } = useToast()
const router = useRouter()
const authStore = useAuthStore()

const logout = () => {
  handleLogout()
}
const handleLogout = async (): Promise<void> => {
  try {
    await authStore.logout()

    init({
      message: "You've successfully signed out",
      color: 'success',
    })

    await router.push({ name: 'login' })
  } catch (error) {
    console.error('Error al cerrar sesión:', error)
  }
}
const Perfil = () => {
  router.push({ name: 'settings' })
}

const Preferencias = () => {
  router.push({ name: 'preferences' })
}
</script>

<style lang="scss" scoped>
.user-menu-dropdown {
  cursor: pointer;

  .user-menu-dropdown__icon {
    position: relative;
    display: flex;
    align-items: center;
  }

  .va-dropdown__anchor {
    display: inline-block;
  }
}
</style>
